<template>
  <div class="setup_wrap">
    <div v-if="active=='first'">
      无法查看
    </div>
    <student v-if="active=='second'"></student>
    <teacher v-if="active=='thrid'"></teacher>
  </div>
</template>
<script>
import student from './studentSetUp.vue'
import teacher from './teacherSetUp.vue'
export default {
  components: { student, teacher },
  data() {
    return {  
      userType: sessionStorage.getItem('userType'), //这里本是localStorage
      active: 'first'
    }
  },
  mounted() {
    if(this.userType==0||this.userType==1){//这里本是0 1 
      this.active = 'thrid'
    }else{
      this.active = 'second'
    }
  },
  methods: {
    
  },
}
</script>
<style lang="scss" >
  .setup_wrap{

  
  padding: 16px 16px 16px 16px;
  width: calc(100% - 32px);
  height: calc(100% - 32px);
  background-color: rgba(244, 244, 244, 1);

   

  
  }

  
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/setUp/index.vue